{
  "search": "खोज",
  "search_no_results_1": "धत्तेरे की!",
  "search_no_results_2": "वह भाव चित्र नहीं मिला",
  "pick": "कोई भाव चित्र चुनें...",
  "add_custom": "रीति भाव चित्र जोड़ें",
  "categories": {
    "activity": "गतिविधि",
    "custom": "रीति",
    "flags": "झंडे",
    "foods": "भोजन पेय",
    "frequent": "बहुधा प्रयुक्त",
    "nature": "पशु और प्रकृति",
    "objects": "वस्तुओं",
    "people": "मुस्कुराहट और लोग",
    "places": "यात्रा और स्थान",
    "search": "खोज के परिणाम",
    "symbols": "प्रतीक"
  },
  "skins": {
    "choose": "शुरुआती रूप चुनें",
    "1": "शुरुआती",
    "2": "हल्का",
    "3": "मध्यम-हल्का",
    "4": "मध्यम",
    "5": "मध्यम-गहरा",
    "6": "गहरा"
  }
}
